const initBlock = async function( $block ) {

	/* eslint-disable */
	$block.find( '.js-scroll-to' ).on( 'click', function( e ) {
		e.preventDefault();
		const target  = $( this ).attr( 'href' );
		const $target = $( target );
		if ( $target.length ) {
			$( 'html, body' ).animate( {
				scrollTop: $target.offset().top
			}, 600 );
		}
	} );

	$block.find( '#bookingForm' ).on( 'submit', handleSubmit );

	// Video play button logic
	$block.find( '.video-frame' ).each( function() {
		const $frame = $( this );
		const $video = $frame.find( 'video' );
		const $playBtn = $frame.find( '.video-frame__play-button' );

		if ( ! $video.length || ! $playBtn.length ) {
			return;
		}

		$playBtn.on( 'click', function() {
			$video[0].play();
		} );

		$video.on( 'play', function() {
			$playBtn.addClass( 'is-hidden' );
		} );

		$video.on( 'pause ended', function() {
			$playBtn.removeClass( 'is-hidden' );
		} );
	} );

	/* ==========================================================================
	   WORKS24 — LEAD ROUTING + CALENDLY EMBED
	   --------------------------------------------------------------------------
	   To swap rep links, edit only the CALENDLY_URLS object below.
	   Texas leads route to Rick Wilson (East of I-35) or Rick Jones (West of
	   I-35) based on the first 3 digits of the prospect's ZIP code.
	   ========================================================================== */

	/* 1) PASTE EACH REP'S CALENDLY LINK BELOW
		  Use the base scheduling URL — e.g. https://calendly.com/rickwilson-works24/intro
		  Query strings are appended automatically at runtime.                          */
	const CALENDLY_URLS = {
		rick_wilson:    'https://calendly.com/rwilson-works24/works24-demo-meeting',
		rick_jones:     'https://calendly.com/rjones-works24/works24-in-person-meeting',
		philip_edwards: 'https://calendly.com/pedwards-works24/introductory-call',
		frank_deprato:  'https://calendly.com/fdeprato-works24/works24-20-minute-intro-call',
		brian_robinson: 'https://calendly.com/brianrobinson/works24_service_review'
	};

	/* 2) DISPLAY NAMES — shown above the embedded calendar. */
	const REP_NAMES = {
		rick_wilson:    'Rick Wilson',
		rick_jones:     'Rick Jones',
		philip_edwards: 'Philip Edwards',
		frank_deprato:  'Frank DePrato',
		brian_robinson: 'Brian Robinson'
	};

	/* 3) STATE → REP MAPPING (50 states + DC).
		  Texas is resolved separately by ZIP — see getTexasRep() below.            */
	const STATE_TO_REP = {
		// Rick Wilson — East of I-35 plus mid-South
		'Arkansas':     'rick_wilson',
		'Iowa':         'rick_wilson',
		'Illinois':     'rick_wilson',
		'Louisiana':    'rick_wilson',
		'Mississippi':  'rick_wilson',
		'Missouri':     'rick_wilson',
		// Rick Jones — West of I-35
		'New Mexico':   'rick_jones',
		'Oklahoma':     'rick_jones',
		// Philip Edwards — East Coast + Northeast
		'Connecticut':         'philip_edwards',
		'Delaware':            'philip_edwards',
		'District of Columbia':'philip_edwards',
		'Florida':             'philip_edwards',
		'Georgia':             'philip_edwards',
		'Maine':               'philip_edwards',
		'Maryland':            'philip_edwards',
		'Massachusetts':       'philip_edwards',
		'New Hampshire':       'philip_edwards',
		'New Jersey':          'philip_edwards',
		'New York':            'philip_edwards',
		'North Carolina':      'philip_edwards',
		'Pennsylvania':        'philip_edwards',
		'Rhode Island':        'philip_edwards',
		'South Carolina':      'philip_edwards',
		'Vermont':             'philip_edwards',
		'Virginia':            'philip_edwards',
		'West Virginia':       'philip_edwards',
		// Frank DePrato — Midwest / mid-Atlantic interior
		'Alabama':   'frank_deprato',
		'Indiana':   'frank_deprato',
		'Kentucky':  'frank_deprato',
		'Michigan':  'frank_deprato',
		'Ohio':      'frank_deprato',
		'Tennessee': 'frank_deprato',
		// Brian Robinson — West / Plains / Pacific
		'Alaska':       'brian_robinson',
		'Arizona':      'brian_robinson',
		'California':   'brian_robinson',
		'Colorado':     'brian_robinson',
		'Hawaii':       'brian_robinson',
		'Idaho':        'brian_robinson',
		'Kansas':       'brian_robinson',
		'Minnesota':    'brian_robinson',
		'Montana':      'brian_robinson',
		'Nebraska':     'brian_robinson',
		'Nevada':       'brian_robinson',
		'North Dakota': 'brian_robinson',
		'Oregon':       'brian_robinson',
		'South Dakota': 'brian_robinson',
		'Utah':         'brian_robinson',
		'Washington':   'brian_robinson',
		'Wisconsin':    'brian_robinson',
		'Wyoming':      'brian_robinson'
	};

	/* 4) TEXAS ZIP-3 ROUTING — East of I-35 → Wilson, West of I-35 → Jones.
		  Based on Texas ZIP geography + corridor-city decisions from the Bauer
		  territory spreadsheet (Fort Worth → West; Dallas, Austin, San Antonio,
		  Waco → East). To re-route a specific prefix, move it between the two
		  sets below.                                                               */
	const TX_WEST_PREFIXES = new Set( [
		'733',                         // Austin-area West portion (overrides for 73301/73344 below)
		'760', '761', '762',           // Fort Worth, Arlington, Denton
		'763', '764',                  // Wichita Falls, Stephenville
		'768', '769',                  // Brownwood, San Angelo
		'788',                         // Uvalde / SW Texas
		'790', '791', '792',           // Amarillo
		'793', '794',                  // Lubbock
		'795', '796',                  // Abilene
		'797', '798', '799',           // Midland, Odessa, El Paso
		'885'                          // El Paso overflow
	] );
	// 5-digit overrides — IRS-only Austin ZIPs that should still go East.
	const TX_FIVE_DIGIT_OVERRIDES_EAST = new Set( ['73301', '73344'] );

	function getTexasRep( zip ) {
		if ( !zip || zip.length < 3 ) {return 'rick_wilson';}            // safe fallback (East)
		if ( TX_FIVE_DIGIT_OVERRIDES_EAST.has( zip.slice( 0, 5 ) ) ) {return 'rick_wilson';}
		return TX_WEST_PREFIXES.has( zip.slice( 0, 3 ) ) ? 'rick_jones' : 'rick_wilson';
	}

	/* 5) RESOLVE which rep gets a given (state, zip).                              */
	function resolveRep( state, zip ) {
		if ( state === 'Texas' ) {return getTexasRep( zip );}
		return STATE_TO_REP[state] || 'rick_wilson';                 // global fallback
	}

	/* 6) FORM SUBMIT — show success state, inject Calendly inline embed,
		  pre-fill prospect details so they only have to pick a time.               */
	function handleSubmit( e ) {
		e.preventDefault();

		const state  = document.getElementById( 'stateField' ).value;
		const zip    = document.getElementById( 'zipField' ).value.trim();
		const repKey = resolveRep( state, zip );
		const repName = REP_NAMES[repKey];
		const url    = CALENDLY_URLS[repKey];

		// Update visible labels
		document.getElementById( 'repName' ).textContent      = repName;
		document.getElementById( 'stateConfirm' ).textContent = state;

		// Build Calendly inline embed (with prefill from the form)
		const container = document.getElementById( 'calendlyContainer' );
		container.innerHTML = ''; // clear any prior state if user resubmits

		const prefill = {
			firstName: document.getElementById( 'firstName' ).value,
			lastName:  document.getElementById( 'lastName' ).value,
			email:     document.getElementById( 'email' ).value,
			customAnswers: { a1: document.getElementById( 'institution' ).value }
		};

		if ( window.Calendly && typeof window.Calendly.initInlineWidget === 'function' ) {
			window.Calendly.initInlineWidget( {
				url: url,
				parentElement: container,
				prefill: prefill
			} );
		} else {
			// Fallback: Calendly widget.js didn't load — render a styled link instead
			container.innerHTML =
				'<a class="form-submit" style="display:inline-block;text-decoration:none;text-align:center;" ' +
				'href="' + url + '" target="_blank" rel="noopener">' +
				'Open ' + repName + '\'s calendar &rarr;</a>';
		}

		// Reveal success block and scroll into view
		document.getElementById( 'bookingForm' ).classList.add( 'hidden' );
		document.getElementById( 'formSuccess' ).classList.add( 'active' );
		document.getElementById( 'formSuccess' ).scrollIntoView( { behavior: 'smooth', block: 'center' } );
	}
};

themeUtils.loadBlock( initBlock, 'letter-landing', '.letter-landing-wrap' );
